import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PokeType from "../Components/PokeType.js";
import getPokemonById from "../Services/getPokemonById.js";

const Pokemon = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dataPokemon, setDataPokemon] = useState({});
  const [typesArr, setTypesArr] = useState([]);
  const [abilitiesArr, setAbilitiesArr] = useState([]);
  const [movementsArr, setMovementsArr] = useState([]);
  const [modal, setModal] = useState("");
  useEffect(() => {
    getPokemonById(id).then((res) => {
      setDataPokemon({
        name: res.data.name,
        image: res.data.sprites.front_default,
        id: res.data.id,
        height: res.data.height,
        weight: res.data.weight,
        hp: res.data.stats[0].base_stat,
        attack: res.data.stats[1].base_stat,
        defense: res.data.stats[2].base_stat,
        speed: res.data.stats[5].base_stat,
      });
      setMovementsArr(res.data.moves);
      setTypesArr(res.data.types);
      setAbilitiesArr(res.data.abilities);
    });
  }, [id]);

  const listTypes = typesArr.map((item) => (
    <PokeType key={item.slot} type={item.type} />
  ));
  const listAbilities = abilitiesArr.map((item, index) => (
    <PokeType key={index} type={item.ability} />
  ));
  const listMovements = movementsArr.map((item, index) => (
    <PokeType key={index} type={item.move} />
  ));

  let sms =
    "the name is" +
    dataPokemon.name +
    "its  weight is+" +
    dataPokemon.weight +
    "max height is" +
    dataPokemon.height +
    "has a hp of" +
    dataPokemon.hp +
    "his attack is" +
    dataPokemon.attack +
    "has a defense of" +
    dataPokemon.defense +
    "this pokemon reachesdata" +
    dataPokemon.speed;

  const hablar = () => {
    let msg = new SpeechSynthesisUtterance();
    const synth = window.speechSynthesis;
    msg.voice = synth.getVoices()[1];
    msg.text = sms;
    msg.rate = 1;
    msg.lang = "en-US";
    window.speechSynthesis.speak(msg);
  };

  let handleModal = () => {
    setModal(!modal ? "iniciarModal" : "cerrarModal");
  };
  return (
    <div>
      {/*  */}
      <p># {dataPokemon.id}</p>
      click the big blue button
      <br />
      <button className="boton" onClick={() => navigate(-1)}>
        back
      </button>
      {/* <!-- modal --> */}
      <section className={`modal ${modal}`}>
        <div className="modal__container">
          <img
            src="https://i.imgur.com/ODHzBFk.png"
            className=""
            style={{ height: "2vw", padding: "0", margin: "0" }}
          />
          <div className="b-radius ">
            movements:
            <div className="cColumns cColumns8 ">{listMovements}</div>
          </div>
          <button
            onClick={() => {
              handleModal();
            }}
            type="button"
            title=""
          >
            close movements
          </button>
        </div>
      </section>
      {/* fin modal */}
      <div id="pokedex">
        <div id="left">
          <div id="logo"></div>
          <div id="bg_curve1_left"></div>
          <div id="bg_curve2_left"></div>
          <div id="curve1_left">
            <div id="buttonGlass">
              <div id="reflect"> </div>
            </div>
            <div id="miniButtonGlass1"></div>
            <div id="miniButtonGlass2"></div>
            <div id="miniButtonGlass3"></div>
          </div>
          <div id="curve2_left">
            <div id="junction">
              <div id="junction1"></div>
              <div id="junction2"></div>
            </div>
          </div>
          <div id="screen">
            <div id="topPicture">
              <div id="buttontopPicture1"></div>
              <div id="buttontopPicture2"></div>
            </div>
            <div id="picture">
              <img src={dataPokemon.image} alt="psykokwak" height="170" />
            </div>
            <div id="buttonbottomPicture"></div>
            <div id="speakers">
              <div className="sp"></div>
              <div className="sp"></div>
              <div className="sp"></div>
              <div className="sp"></div>
            </div>
          </div>
          <div onClick={() => hablar()} id="bigbluebutton"></div>
          <div id="barbutton1"></div>
          <div id="barbutton2"></div>
          <div id="cross">
            <div id="leftcross">
              <div id="leftT"></div>
            </div>
            <div id="topcross">
              <div id="upT"></div>
            </div>
            <div id="rightcross">
              <div id="rightT"></div>
            </div>
            <div id="midcross">
              <div id="midCircle"></div>
            </div>
            <div id="botcross">
              <div id="downT"></div>
            </div>
          </div>
        </div>
        <div id="right">
          <div id="stats">
            <div className="t-titleS">{dataPokemon.name}</div>
            <div className="tA-left">
              <p className="t-normalS">weight: {dataPokemon.weight}</p>
              <p className="t-normalS">height: {dataPokemon.height}</p>
              <p className="t-normalS">HP: {dataPokemon.hp}</p>
              <p className="t-normalS">attack: {dataPokemon.attack}</p>
              <p className="t-normalS">defense: {dataPokemon.defense}</p>
              <p className="t-normalS">speed: {dataPokemon.speed}</p>
            </div>
          </div>
          <div id="blueButtons1">
            <div className="blueButton"></div>
            <div className="blueButton"></div>
            <div className="blueButton"></div>
            <div className="blueButton"></div>
            <div className="blueButton"></div>
          </div>
          <div id="blueButtons2">
            <div className="blueButton"></div>
            <div className="blueButton"></div>
            <div className="blueButton"></div>
            <div className="blueButton"></div>
            <div className="blueButton"></div>
          </div>
          <div id="miniButtonGlass4"></div>
          <div id="miniButtonGlass5"></div>
          <div id="barbutton3"></div>
          <div id="barbutton4"></div>
          <div id="yellowBox1">
            <div className="t-normalS pad-top1"> types:{listTypes}</div>
          </div>
          <div id="yellowBox2">
            <div className="t-normalS pad-top1"> abilities:{listAbilities}</div>
          </div>
          <div id="bg_curve1_right"></div>
          <div id="bg_curve2_right"></div>
          <div id="curve1_right"></div>
          <div id="curve2_right"></div>
        </div>
      </div>
      <br />
      <button
        className="boton"
        onClick={() => {
          handleModal();
        }}
        type="button"
        title=""
      >
        view movements
      </button>
    </div>
  );
};

export default Pokemon;
